import { Space } from "antd"
import { InvoiceDetail, InvoiceSummary } from "../../../domain/invoicing/invoice"
import { faEye } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ThemableButton from "../../Items/ThemableButton"
import { green } from "@ant-design/colors"

type Props = {
  detail: InvoiceDetail
  summary: InvoiceSummary
}

const ViewReceiptButton = ({detail, summary}: Props) => {
  if (detail.paymentPageUrl?.length < 1) {
    return null
  }

  if (summary.balance > 0) {
    return null
  }

  return <ThemableButton
      type="primary"
      colorPrimary={green.primary}
      onClick={() => window.open(detail.paymentPageUrl, '_blank')}
    >
    <Space>
      <FontAwesomeIcon icon={faEye} />
      View Receipt
    </Space>
  </ThemableButton>
}

export default ViewReceiptButton
